import { PkBadge, PkBottomPanel, PkButton } from '@uefadigital/panenka-react';
import { memo, useEffect } from 'react';

import { useTeam, useTeamInterestOptions } from '../../store';

import { useTranslateFn } from '@shared/Translate';
import GoogleTagManagerHelper from '@tracking/gtm-helper';

import * as styles from '../styles.module.scss';

const DownloadApp = () => {
  const t = useTranslateFn();
  const { team, status, setStatus } = useTeam();
  const { options } = useTeamInterestOptions();

  const setDownloadApp = () => {
    GoogleTagManagerHelper.ga4Event('panel_dialog_main_action', {
      section_reference: 'app download fav team detection',
      interaction: 'Main action',
    });
  };

  useEffect(() => {
    GoogleTagManagerHelper.ga4Event('panel_dialog_loaded', {
      section_reference: 'app download fav team detection',
      interaction: 'Dialog - Loaded',
    });
  }, []);

  const closeDialogByButton = () => {
    GoogleTagManagerHelper.ga4Event('panel_dialog_secondary_action', {
      section_reference: 'app download fav team detection',
      interaction: 'Dialog - Secondary action',
    });
    setStatus('joining');
    GoogleTagManagerHelper.ga4Event('panel_dialog_loaded', {
      section_reference: 'join MyUEFA',
      interaction: 'Dialog - Loaded',
    });
  };

  const closeDialog = () => {
    GoogleTagManagerHelper.ga4Event('panel_dialog_skip', {
      section_reference: 'app download fav team detection',
      interaction: 'Dialog - Skip',
    });
  };

  if (!team) return;

  return (
    <PkBottomPanel opened={status === 'download'} onPkClose={closeDialog} focusOnOpen>
      <div slot='title' className='pk-d--flex pk-mb--0'>
        <PkBadge
          alt={team.displayName}
          slot='badge'
          badgeTitle={team.displayName}
          fallbackImage='club-generic-badge'
          size={48}
          src={team.logoUrl}
        />
        <div className='pk-d--flex pk-flex--column pk-ml--m'>
          <div className={styles.panelTitle}>{t('quick_access_to_team', { replace: [team.displayName] })}</div>
          <div className={styles.panelSummary}>{t('quick_access_summary')}</div>
        </div>
      </div>

      <div slot='actions'>
        {!!options?.appDownloadUrl && (
          <PkButton
            className='pk-w--100'
            aria-label={t('download_the_app')}
            onPkClick={setDownloadApp}
            linkHref={options.appDownloadUrl}
          >
            {t('download_the_app')}
          </PkButton>
        )}
        <PkButton
          aria-label={t('not_now')}
          className='pk-w--100 pk-mt--m'
          onPkClick={closeDialogByButton}
          appearance='outlined'
        >
          {t('not_now')}
        </PkButton>
      </div>
    </PkBottomPanel>
  );
};

export default memo(DownloadApp);
